import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import Button from '@mui/material/Button';
import React from 'react';
import styles from './challenge.module.css';
import { Category } from '../../types/Category';
import ChallengeDialog from '../../components/Dialogs/ChallengeDialog';
import childrenImage from '../../assets/children.svg';
import { ChallengeMode } from '../../types/enums';
import { useGameSocket } from '../../providers/gameSocket.provider';
import logo from '../../assets/mtc logo.png';
import { useNavigate, useParams } from 'react-router-dom';
import { ChallengeReadyPayload } from '../../types/socket.types';
import { useChallenge } from '../../contexts/challenge.context';

interface PageState{ start: number; end: number; }

const ChallengeScreen: React.FC<any> = ()=>{

    // Refs
    const selectedCategory = React.useRef<Category>();
    const selectedMode = React.useRef<ChallengeMode>();
    let isRendered = React.useRef<boolean>(false);

    // Hooks
    const { gameSocket } = useGameSocket();
    const { host } = useParams();
    const navigate = useNavigate();
    const { challenges, roundId } = useChallenge()

    // State
    const [pageState, setPageState] = React.useState<PageState>({ start: 0, end: 5 });
    const [open, setOpen] = React.useState<boolean>(false);

    // Handlers
    const handleNextPage = ()=>{
        //setMarginIndex((prevIndex)=> prevIndex + 1);
        let newPageStart = pageState.start + 1;
        let newPageEnd = pageState.end + 1;
        
        if (newPageEnd <= challenges.length) {
            setPageState({ start: newPageStart, end: newPageEnd })
        }
    }
    const handlePrevPage = ()=>{
        //setMarginIndex((prevIndex)=> prevIndex - 1);
        let newPageStart = pageState.start - 1;
        let newPageEnd = pageState.end - 1;
        
        
        if (newPageStart >= 0) {
            setPageState({ start: newPageStart, end: newPageEnd })
        }
    }

    const handleChallengeSelect = (category: Category, mode: ChallengeMode)=>{
        selectedCategory.current = category;
        selectedMode.current = mode;
        setOpen(true)
    }

    const handleClose = ()=> setOpen(false);

    const handleContinue = () =>{

        const isNotBlocked = selectedCategory.current &&
        selectedMode.current !== undefined &&
        !!roundId

        if (isNotBlocked) {
            gameSocket?.emit('challenge-select', {
                challenge: selectedCategory.current,
                mode: selectedMode.current,
                code: host
            })
            window.location.href = `/${host}/game/${roundId}`
            // navigate(`/${host}/game/${roundId}`)
        }
    }

    // Helpers
    const renderBox = (item: Category, index: number)=>{

        if (index >= 5) {
            return(
                <div className={styles.hiddenBoxContainer} onClick={()=> handleChallengeSelect(item, ChallengeMode.FIXED_TIME)}>
                    <div className={`${styles.box} ${styles.fixed}`} key={`rd${index}`}>
                        <h3>{item.name}</h3>
                    </div>
                </div>
            )
        }

        return(
            <div className={styles.boxContainer} onClick={()=> handleChallengeSelect(item, ChallengeMode.FIXED_TIME)}>
                <div className={`${styles.box} ${styles.fixed}`} key={`rd${index}`}>
                    <h3>{item.name}</h3>
                </div>
            </div>
        )
    }

    const renderBox2 = (item: Category, index: number)=>{

        //console.log(item);

        if (index >= 5) {
            return(
                <div className={styles.hiddenBoxContainer} onClick={()=> handleChallengeSelect(item, ChallengeMode.SUDDEN_DEATH)}>
                    <div className={`${styles.box} ${styles.sudden}`} key={`rd2${index}`}>
                        <h3>{item.name}</h3>
                    </div>
                </div>
            )
        }

        return(
            <div className={styles.boxContainer} onClick={()=> handleChallengeSelect(item, ChallengeMode.SUDDEN_DEATH)}>
                <div className={`${styles.box} ${styles.sudden}`} key={`rd2${index}`}>
                    <h3>{item.name}</h3>
                </div>
            </div>
        )
    }

    const renderNumberLabels = ()=>{
        let { start, end } = pageState;
        let labels = [];

        for (let i = start; i < end; i++) {
            labels.push(
                <div className={`${styles.boxContainer} ${styles.label}`}>
                    <h3>{i + 1}</h3>
                </div>
            )
        }

        return labels;
    }

    // Elements
    const preview = (
        <div className={styles.logoContainer}>
            <div className={styles.logo}>
                <img src={logo} alt="MTC logo" />
            </div>
        </div>
    )
    const challengeView = (
        <div className={styles.container}>
            <div className={styles.title}>
                <h3>Select a challenge</h3>
            </div>

            {/** Grid display */}
            <div>

                {/** Carousel buttons */}
                <div className={styles.buttons}>
                    {
                        pageState.start > 0 &&
                        <Button
                            onClick={handlePrevPage}
                            sx={{
                                color: 'white',
                            }}
                        >
                            <KeyboardArrowLeft sx={{color: 'white'}}/>
                            Previous
                        </Button>
                    }
                    {
                        pageState.end < challenges.length &&
                        <Button
                            onClick={handleNextPage}
                            sx={{
                                color: 'white',
                            }}
                        >
                            Next
                            <KeyboardArrowRight sx={{color: 'white'}}/>
                        </Button>
                    }
                </div>

                {/** Numbers */}
                {/* <div className={`${styles.row} ${styles.top}`}>
                    <div className={styles.mode}>
                        <h3></h3>
                    </div>
                    { renderNumberLabels() }
                </div> */}

                {/** Fixed Time Mode */}
                <div className={`${styles.row} ${styles.top}`}>
                    <div className={styles.mode}>
                        <h3>FIXED TIME MODE</h3>
                    </div>
                    <div className={styles.challegeRow}>
                        { 
                            challenges
                            .slice(pageState.start, pageState.end).map(renderBox) 
                        }
                    </div>
                </div>

                {/** Sudden Death Mode */}
                <div className={styles.row}>
                    <div className={styles.mode}>
                        <h3>SUDDEN DEATH MODE</h3>
                    </div>
                    <div className={styles.challegeRow}>
                        { 
                            challenges
                            .slice(pageState.start, pageState.end).map(renderBox2) 
                        }
                    </div>
                </div>

                
            </div>

            {/** Children Vector */}
            <div className={styles.childrenVector}>
                <img src={childrenImage} alt="Children playing svg" />
            </div>

        </div>
    )
 

    
    return(
        <>
            <ChallengeDialog 
                open={open} onClose={handleClose}
                challenge={selectedCategory.current}
                mode={selectedMode.current}
                onContinue={handleContinue}
            />
            { challenges.length > 0 && challengeView }
            { challenges.length === 0 && preview }
        </>
    )
}

export default ChallengeScreen;